import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Col, Row } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Routes from 'routing/Routes';

const ArchiveLicenseStatus = React.createClass({
  propTypes: {
    licenseStatus: PropTypes.shape({
      status: PropTypes.object,
      missing: PropTypes.bool.isRequired,
      loading: PropTypes.bool.isRequired,
    }).isRequired,
    colWidth: PropTypes.number,
    rowClass: PropTypes.string,
    summary: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      colWidth: 12,
      rowClass: 'content',
      summary: false,
    };
  },

  renderStatus() {
    return (
      <Alert bsStyle="danger">
        <h4 style={{ fontWeight: 'bold', marginBottom: 5 }}>Archive creation is disabled</h4>
        <p>
          Archive creation is disabled because there is no valid license.
          You can still restore existing archives, but Graylog will not create new ones.
        </p>
        <p>
          See <LinkContainer to={Routes.pluginRoute('SYSTEM_LICENSES')}><a>Licenses page</a></LinkContainer> for details.
        </p>
      </Alert>
    );
  },

  render() {
    const { status, missing } = this.props.licenseStatus;

    if (!missing && (status && status.valid)) {
      return null;
    }

    const { summary, rowClass, colWidth } = this.props;

    if (summary) {
      return this.renderStatus();
    }

    return (
      <Row className={rowClass}>
        <Col md={colWidth}>
          {this.renderStatus()}
        </Col>
      </Row>
    );
  },
});

export default ArchiveLicenseStatus;



// WEBPACK FOOTER //
// ./src/web/components/ArchiveLicenseStatus.jsx